import type { Bank } from "../api";
import BankLogo from "./BankLogo";
import { formatAccountNumberDisplay, formatAmount } from "../format";

type Props = {
  bank: Bank;
  accountNumber: string;
  amount: number | undefined;
  purpose: string;
  onEdit: () => void;
  onConfirm: () => void;
  submitting: boolean;
};

export default function ConfirmStep({ bank, accountNumber, amount, purpose, onEdit, onConfirm, submitting }: Props) {
  return (
    <section className="step confirm-step" aria-labelledby="step3-title">
      <h1 id="step3-title" className="step-title">
        Kiểm tra lại giúp mình nhé
      </h1>

      <div className="confirm-card">
        <div className="confirm-row confirm-bank">
          <BankLogo bank={bank} size={48} />
          <div>
            <span className="confirm-label">Ngân hàng</span>
            <strong className="confirm-value">{bank.shortName}</strong>
          </div>
        </div>

        <div className="confirm-row">
          <span className="confirm-label">Số tài khoản</span>
          <strong className="confirm-value confirm-value-lg">{formatAccountNumberDisplay(accountNumber)}</strong>
        </div>

        <div className="confirm-row">
          <span className="confirm-label">Số tiền</span>
          <strong className="confirm-value confirm-value-lg">
            {amount === undefined ? "Người gửi tự nhập" : `${formatAmount(amount)} ₫`}
          </strong>
        </div>

        {purpose ? (
          <div className="confirm-row">
            <span className="confirm-label">Nội dung</span>
            <strong className="confirm-value">{purpose}</strong>
          </div>
        ) : null}
      </div>

      <p className="confirm-warning">
        Mã QR nhận tiền sai số tài khoản là tiền chuyển nhầm, không lấy lại được. Hãy kiểm tra kỹ trước khi tạo mã.
      </p>

      <div className="confirm-actions">
        <button type="button" className="btn btn-secondary" onClick={onEdit} disabled={submitting}>
          Sửa lại
        </button>
        <button type="button" className="btn btn-primary" onClick={onConfirm} disabled={submitting}>
          {submitting ? "Đang tạo mã…" : "Đúng rồi, tạo mã"}
        </button>
      </div>
    </section>
  );
}
